import { Component } from '@angular/core';
import { GlobalLoadingService } from '../../global-services/global-loading.service';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

@Component({
    selector: 'app-global-loading',
    templateUrl: './global-loading.component.html',
    imports: [...COMMON_IMPORTS],
    styleUrls: ['./global-loading.component.css']
})
export class GlobalLoadingComponent {
  loading$ = this.globalLoadingService.loading$;

  constructor(private globalLoadingService: GlobalLoadingService) {
    // Subscribe to the loading observable to trigger change detection
    this.loading$.subscribe((loading) => {
      if (loading) {
        console.log('Loading started');
      } else {
        console.log('Loading finished');
      }
    });
  }
}
